import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewDiscoveryConfigPageNew from "../../components/DiscoveryConfig/ViewDiscoveryConfigPage"


const ViewDiscoveryConfigPage= () => {
  return (
    <>
      <MasterLayout>

        <Breadcrumb id="title" title="View Compatibility Algorithm" title2="Compatibility Algorithm" link2="/discovery-config" />

        <ViewDiscoveryConfigPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewDiscoveryConfigPage;
